import {
  EMAIL_RECIPIENT_TYPE_APPLICANT,
  EMAIL_RECIPIENT_TYPE_OTHERS,
  EMAIL_RECIPIENT_TYPE_PROVIDERS,
} from '../RequestProfileTabEmails'

export const REQUEST_PROFILE_EMAIL_AUDIENCE_MODAL_RECIPIENTS_FIELD_NAME =
  'recipients'

export const QA_NAME_REQUEST_PROFILE_EMAIL_AUDIENCE_MODAL =
  'request_profile_email_audience_modal'

const REQUEST_PROFILE_EMAIL_AUDIENCE_MODAL_APPLICANT_OPTION = {
  label: 'RequestProfile.EmailAudienceModalApplicantRecipientKey',
  value: EMAIL_RECIPIENT_TYPE_APPLICANT,
}

const REQUEST_PROFILE_EMAIL_AUDIENCE_MODAL_PROVIDERS_OPTION = {
  label: 'RequestProfile.EmailAudienceModalProvidersRecipientKey',
  value: EMAIL_RECIPIENT_TYPE_PROVIDERS,
}

const REQUEST_PROFILE_EMAIL_AUDIENCE_MODAL_OTHERS_OPTION = {
  label: 'RequestProfile.EmailAudienceModalOthersRecipientKey',
  value: EMAIL_RECIPIENT_TYPE_OTHERS,
}

export const REQUEST_PROFILE_EMAIL_AUDIENCE_MODAL_DEFAULT_OPTION =
  REQUEST_PROFILE_EMAIL_AUDIENCE_MODAL_APPLICANT_OPTION

export const REQUEST_PROFILE_EMAIL_AUDIENCE_MODAL_OPTIONS = [
  REQUEST_PROFILE_EMAIL_AUDIENCE_MODAL_APPLICANT_OPTION,
  REQUEST_PROFILE_EMAIL_AUDIENCE_MODAL_PROVIDERS_OPTION,
  REQUEST_PROFILE_EMAIL_AUDIENCE_MODAL_OTHERS_OPTION,
]
